module.exports = __webpack_public_path__ + "fonts/quicksand-latin-400-normal.5706f93.woff2";